<template>
  <div class="my-giving p-4 h-auto rounded-md">
    <div class="next-schedule">
      <div class="mb-8">
        <h4 class="text-content font-bold text-14">
          {{ $t("Next Scheduled Donation") }}
        </h4>
        <p class="text-content text-12 flex">
          <span>
            <img
              class="object-cover mt-1 mr-1"
              :srcset="`${calendarImg}, ${calendarImg}`"
              :src="calendarImg"
              alt="Thrive"
            />
          </span>
          {{ monthLastDate }}
        </p>
      </div>
      <div class="relative">
        <div class="my-8 border-l border-l-3 pl-1">
          <h4 class="text-content font-bold text-14">
            {{ $t("Min Goal") }}
          </h4>
          <p class="text-content text-14">
            ${{ $getState("minAmount") }}
          </p>
        </div>
        <div class="my-8 border-l border-l-3 pl-1">
          <h4 class="text-content font-bold text-14">
            {{ $t("Max Goal") }}
          </h4>
          <p class="text-content text-14">
            ${{ $getState("maxAmount") }}
          </p>
        </div>
        <div class="progress-bar absolute">
          <vue-ellipse-progress
            :data="circles"
            empty-color="#eef0f2"
            :size="180"
            :thickness="thickness"
            :gap="10"
            :lineMode="lineMode"
            emptyThickness="2"
            animation="rs 700 200"
            fontSize="1.5rem"
            font-color="white"
            :dot="dot"
            line="round"
          >
            <span
              class="text-14 font-bold text-content"
              slot="legend-caption"
            >
              ${{ circularValue }}
            </span>
            <p class="text-7 text-content" slot="legend-caption">
              Monthly Total
            </p>
          </vue-ellipse-progress>
        </div>
      </div>
    </div>

    <div class="pt-3">
      <div>
        <span class="text-16 font-bold text-content pr-4">
          Total Potential
        </span>
        <span class="text-16 text-content font-bold">${{ $getState("monthDonation") }}</span>
      </div>
      <div>
        <span class="text-12 text-black-2">Total amount you can potentially give</span>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../UI/Button";

export default {
  name: "Giving",
  components: {
    Button
  },
  data: function() {
    return {
      hasCards: false,
      monthLastDate: "",
      circles: [
        {
          progress: 0,
          emptyThickness: 3,
          animation: "rs 1500 500",
          color: "#DB8633"
        },
        {
          progress: 0,
          animation: "rs 1500 500",
          color: "#DB8633"
        }
      ],
      thickness: 18,
      emptyThickness: "1%",
      dot: {
        size: "13%",
        backgroundColor: "#DB8633",
        left: "10px"
      },
      lineMode: "in-over"
    };
  },
  beforeUpdate() {
    if (this.$getState("corporation")["is"]) {
      this.circles[0]["color"] = this.$getState("corporation")[
        "color_background"
      ];
      this.circles[1]["color"] = this.$getState("corporation")[
        "color_background"
      ];

      this.dot.backgroundColor = this.$getState("corporation")[
        "color_background"
      ];
    }
  },
  mounted() {
    this.getStatistic();
  },
  computed: {
    calendarImg () {
      return `${this.$store.state.appUrl}/img/pwa/navigation/calendar.png`
    },
    circularValue () {
      return this.$getState('monthDonation') > this.$getState('maxAmount') ? this.$getState('maxAmount') : this.$getState('monthDonation')
    }
  },

  methods: {
    srtReplace: function() {
      if (this.$user("is_pause_donation")) {
        return this.$t("Donations paused");
      }

      if (!this.hasCards) {
        return this.$t("You have $0 in scheduled donations every month");
      } else {
        let str = this.$t("Your donation on {date} will be ${summa}");
        return str
          .replace("{date}", this.$currentDate)
          .replace("{summa}", this.$getState("monthDonation"));
      }
    },
    getStatistic: function() {
      this.$http.post("user/donationsstat").then(res => {
        if (res && res.status !== undefined && res.status) {
          this.monthLastDate = res.data.month_last_date;

          this.hasCards =
            res.data.hasCards !== undefined ? res.data.hasCards : false;

          let minAmount =
            res.data?.user_min_goal !== undefined
              ? res.data?.user_min_goal
              : parseInt(0);
          let maxAmount =
            res.data?.user_max_goal !== undefined
              ? res.data?.user_max_goal
              : parseInt(0);

          let monthDonation = res.data.total;

          let minPercentage = (monthDonation / minAmount) * 100;
          let maxPercentage = (monthDonation / maxAmount) * 100;

          if (monthDonation > minAmount && minAmount > 0) {
            minPercentage = 100;
          }

          if (monthDonation > maxAmount && maxAmount > 0) {
            maxPercentage = 100;
          }

          this.circles[0].progress = maxPercentage ? maxPercentage : 0;
          this.circles[1].progress = minPercentage ? minPercentage : 0;

          this.$setState("maxAmount", Number(parseFloat(maxAmount).toFixed(2)));
          this.$setState("minAmount", Number(parseFloat(minAmount).toFixed(2)));
          this.$setState(
            "monthDonation",
            Number(parseFloat(res.data.total).toFixed(2))
          );
          this.$setState(
            "lastTransaction",
            parseFloat(res.data.last_transaction).toFixed(2)
          );
          this.$setState(
            "lastRoundUps",
            parseFloat(res.data.last_roundups).toFixed(2)
          );
        }
      });
    }
  }
};
</script>
